export const IN_PROGRESS = 'inProgress'
export const SUCCESS = 'success'
export const FAILURE = 'failure'
